/* eslint @typescript-eslint/no-explicit-any: 0 */
import _ from 'lodash';
import option from './option';

function extractNumberAndMultiply(
    value: string | null | undefined,
    multiplier: number
): number {
    const number = Number((value ?? '0').replace(/[^0-9]/g, ''));
    return number * multiplier;
}

function extractNumber(
    value: string | null | undefined,
    positive = false
): number {
    const getMultiplier = () => (value?.trim().startsWith('-') ? -1 : 1);
    return extractNumberAndMultiply(value, positive ? 1 : getMultiplier());
}

type FormValuesParser<T extends Record<string, any>> = {
    [P in keyof T]: (val: P) => T[P];
};

function parseFormValues<T extends Record<string, any>>(
    values: T | Record<string, any>,
    parsers: Partial<FormValuesParser<T>>
): T {
    return Object.entries(values).reduce(
        (result, [key, value]) => ({
            ...result,
            [key]: option.map(parsers[key] ?? _.identity, value),
        }),
        {}
    ) as T;
}

export default { extractNumber, parseFormValues };
